// Central brand + contact data — replace values here to update the entire site.
// -----------------------------------------------------------------------------
// PHONE / WHATSAPP:   change PHONE and WHATSAPP below (use country code, no +).
// GOOGLE MAPS EMBED:  MAP_EMBED points to the Google Maps embed for the property.
// INSTAGRAM:          replace INSTAGRAM with the profile URL.
// HERO VIDEO / IMAGE: HERO_VIDEO (mp4) and HERO_POSTER (jpg). Drop your own here.
// LOGO / GALLERY:     LOGO, ESTATE_IMG, TRAIL_IMG. Replace with your own photos.
// -----------------------------------------------------------------------------

export const BRAND = {
  name: "Hashtag Sakleshpura Homestay",
  location: "Sakleshpura · Karnataka",
  tagline: "Stay · Relax · Explore",
  address: "Hiridanahalli, Sakleshpura, Karnataka 573123, India",
};

export const PHONE = "919972411379";
export const PHONE_DISPLAY = "+91 99724 11379";
export const WHATSAPP = "919972411379";
export const WHATSAPP_MSG = encodeURIComponent(
  "Hello, I would like to book a room at your homestay."
);
export const WA_URL = `https://wa.me/${WHATSAPP}?text=${WHATSAPP_MSG}`;

export const INSTAGRAM =
  "https://www.instagram.com/hashtag_sakleshpura?igsh=MTk0M2EzcWhtd3g0cw%3D%3D&utm_source=qr";

export const MAP_LINK = "https://maps.app.goo.gl/wA6L51xt4z8vdEf6A";
export const MAP_EMBED =
  "https://www.google.com/maps?q=Hashtag+Homestay+Sakleshpura+Hiridanahalli&output=embed";

// --- Credit block ---
export const CREDIT = {
  by: "Sunil",
  link: "https://smartmarketingchikmagalur.netlify.app",
};

// --- User-uploaded assets ---
export const LOGO =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_bdb86082-3185-4f38-a572-406d9aa61255/artifacts/f1vzn9ss_logo.jfif";
export const HERO_VIDEO =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_bdb86082-3185-4f38-a572-406d9aa61255/artifacts/lk18e7gw_drone%20video.mp4";
export const HERO_POSTER =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_bdb86082-3185-4f38-a572-406d9aa61255/artifacts/35rsa8z8_image%20hero.jpg";
export const ESTATE_IMG =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_bdb86082-3185-4f38-a572-406d9aa61255/artifacts/ilash1b3_cofee%20estete.jpg";
export const TRAIL_IMG =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_bdb86082-3185-4f38-a572-406d9aa61255/artifacts/5fw20n2u_image%204.jfif";

// Campfire section — two images shown stacked in a light two-column layout.
export const CAMPFIRE_IMG_1 =
  "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/8xsxjmuq_campfire.jfif";
export const CAMPFIRE_IMG_2 =
  "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/1ng6t55f_campfire%203.jfif";

// Rooms — "Couples Retreat" renamed to "The Estate Retreat"; images replaced.
export const ROOMS = [
  {
    id: "room-1",
    type: "The Estate Retreat",
    blurb:
      "A quiet room at the far edge of the estate. Warm lamplight, wide window, a coffee-scented breeze, and mornings that arrive slowly.",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/pmhv3fvu_room%20one.jfif",
    features: ["Comfy bed", "Estate view", "Hot water", "Free Wi-Fi"],
  },
  {
    id: "room-2",
    type: "Family Rooms",
    blurb:
      "Twin beds, wide curtains, room to spread out. Built for slow family days and long afternoon naps to the sound of the estate.",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/don28xbe_image%20four.jfif",
    features: ["Sleeps 4–5", "Twin beds", "Hot water", "Free Wi-Fi"],
  },
  {
    id: "room-3",
    type: "Groups & Friends",
    blurb:
      "A larger room with a lounge corner, table and comfortable beds. Common veranda outside, and a firepit that has seen every reunion through.",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/hkcztkm5_room%20three.jfif",
    features: ["Sleeps 6–10", "Lounge area", "Hot water", "Free Wi-Fi"],
  },
];

// Malnad food menu — added "Traditional Akki Rotti with Chutney" to balance the grid.
export const FOOD = [
  {
    name: "Malnad Style Dosa",
    note: "Lace-thin rice crepes cooked slow, served with fresh coconut chutney.",
    img: "https://images.unsplash.com/photo-1668236543090-82eba5ee5976?auto=format&fit=crop&w=1000&q=70",
  },
  {
    name: "Malnad Style Chicken Curry",
    note: "Country chicken slow-simmered in coconut, curry leaves and black pepper.",
    img: "https://images.unsplash.com/photo-1631292784640-2b24be784d5d?auto=format&fit=crop&w=1000&q=70",
  },
  {
    name: "Malnad Kadubu",
    note: "Rice-flour flatbread pressed with onion and coriander, hot off the stone.",
    img: "https://images.unsplash.com/photo-1630383249896-424e482df921?auto=format&fit=crop&w=1000&q=70",
  },
  {
    name: "Malnad Style Idly with Chutney",
    note: "Soft steamed idlis paired with coconut chutney and a spoon of ghee.",
    img: "https://images.unsplash.com/photo-1589301760014-d929f3979dbc?auto=format&fit=crop&w=1000&q=70",
  },
  {
    name: "Traditional Akki Rotti with Chutney",
    note: "Rice-flour rotti hand-pressed with onion, coriander and green chilli, crisped on the tawa.",
    img: "https://images.unsplash.com/photo-1567337710282-00832b415979?auto=format&fit=crop&w=1000&q=70",
  },
  {
    name: "Estate Filter Coffee",
    note: "From our own beans, roasted small-batch, poured hot at sunrise.",
    img: "https://images.unsplash.com/photo-1509785307050-d4066910ec1e?auto=format&fit=crop&w=1000&q=70",
  },
];

// 10 tasteful reviews (was 5).
export const REVIEWS = [
  {
    name: "Aarushi & Rohan",
    from: "Bengaluru",
    body:
      "We slept to rain, woke to fog, and forgot our phones for a whole weekend. The room was quiet in a way that Bengaluru had made us forget was possible.",
  },
  {
    name: "The Menon Family",
    from: "Kochi",
    body:
      "Two kids, two grandparents, one very happy family. The family room suited us perfectly and the Malnad dinner is still being talked about.",
  },
  {
    name: "Kabir Singh",
    from: "Mumbai",
    body:
      "We booked the group room for a college reunion. Off-road, campfire, filter coffee at 6 a.m. — genuinely the best trip we've done as a group in years.",
  },
  {
    name: "Ananya Rao",
    from: "Hyderabad",
    body:
      "Hashtag view point is a two-minute walk and it is worth every one of the 240 metres. The hosts are warm, unrushed, and know the estate like family.",
  },
  {
    name: "Devika & Arjun",
    from: "Chennai",
    body:
      "The trek to Hosahalli Gudda was the highlight — mist, birdsong, and a hot idli waiting at the end of it. We will be back in monsoon.",
  },
  {
    name: "Neha Kulkarni",
    from: "Pune",
    body:
      "Every window of the room is a painting. The stars at night are unreal — we sat outside till 2 a.m. without noticing the time.",
  },
  {
    name: "Farhan & Zoya",
    from: "Delhi",
    body:
      "We came for two nights and extended to four. The chicken curry, the rain on the tin roof, the campfire — everything felt handmade.",
  },
  {
    name: "The Gowda Family",
    from: "Mysuru",
    body:
      "Kids ran barefoot on the estate all day. Warm hosts, clean rooms, hot water on tap, and food that tasted like home. Full marks.",
  },
  {
    name: "Ishaan & friends",
    from: "Bengaluru",
    body:
      "Booked the group room with seven of us. The off-road ride and the private camping spot made it a proper adventure. Already planning the next trip.",
  },
  {
    name: "Meera Prasad",
    from: "Mangaluru",
    body:
      "A weekend of long walks and slow coffee. The view point is stunning at sunrise. Everyone at Hashtag treats you like family — we felt very looked after.",
  },
];

// Attractions — Hosahalli Gudda image replaced with user asset.
export const ATTRACTIONS = [
  {
    n: "01",
    name: "Hosahalli Gudda Shooting Point",
    distance: "1.1 km",
    time: "3 min",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/b5m5hi0c_hosalli%20gudda.jfif",
  },
  {
    n: "02",
    name: "Hosahalli Betta",
    distance: "4.4 km",
    time: "14 min",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/oq677ka3_hosahalli%20gudda.jfif",
  },
  {
    n: "03",
    name: "Hashtag View Point",
    distance: "240 m",
    time: "1 min",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/whcm0k08_hosahalli%20view%20point.jfif",
  },
  {
    n: "04",
    name: "Mookanamane Abbi Falls",
    distance: "12 km",
    time: "25 min",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/0spi6sm5_mookane%20falls.jfif",
  },
  {
    n: "05",
    name: "Kaginahare Forest",
    distance: "13 km",
    time: "29 min",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/z2ezatu8_kaginere%20forest.jfif",
  },
  {
    n: "06",
    name: "Manjarabad Fort",
    distance: "18 km",
    time: "35 min",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/omw8jjdm_manjarabad%20port.jfif",
  },
  {
    n: "07",
    name: "Bettada Byraveshwara Temple",
    distance: "55 km",
    time: "1 h 34 min",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/cm59bzc4_bettada%20byreshwara%20temeple.jfif",
  },
  {
    n: "08",
    name: "Sakleshpura Railway Station",
    distance: "28 km",
    time: "44 min",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_sakleshpura-retreat/artifacts/ot9eilr4_sakaleshpura.jfif",
  },
];

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Rooms", href: "#rooms" },
  { label: "Campfire", href: "#fire" },
  { label: "Food", href: "#food" },
  { label: "Reviews", href: "#reviews" },
  { label: "Places", href: "#places" },
  { label: "Book", href: "#book" },
];
